"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEnvVarWithOverride = exports.createOverrideEnvVar = exports.overrideEnvVar = exports.createGetEnvVarWithOverride = exports.getEnvVarWithOverride = exports.createGetEnvVar = exports.getEnvVar = exports.setEnvironment = exports.getEnvironment = void 0;
var window_1 = require("./window");
var overrides = {};
var canaryEnvs = [
    'staging',
    'staging-app',
    'stg.dashboard',
    'integration',
    'integration-app',
];
var isCanaryEnvironment = function () {
    var _a, _b;
    // Return true for review apps and the `canaryEnvs`
    return ((_b = (_a = window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.location) === null || _a === void 0 ? void 0 : _a.host) === null || _b === void 0 ? void 0 : _b.includes('dev.hopininternal')) ||
        canaryEnvs.some(function (canaryEnv) { var _a, _b; return (_b = (_a = window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.location) === null || _a === void 0 ? void 0 : _a.host) === null || _b === void 0 ? void 0 : _b.includes("".concat(canaryEnv, ".hopin")); });
};
var environmentKey = 'hopin-constants-environment';
var getEnvironment = function () {
    var _a, _b;
    return (window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.localStorage.getItem(environmentKey)) ||
        isCanaryEnvironment()
        ? 'canary'
        : ((_b = (_a = window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.location) === null || _a === void 0 ? void 0 : _a.host) === null || _b === void 0 ? void 0 : _b.includes('localhost'))
            ? 'development'
            : 'production';
};
exports.getEnvironment = getEnvironment;
var setEnvironment = function (environment) {
    return window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.localStorage.setItem(environmentKey, environment);
};
exports.setEnvironment = setEnvironment;
var getEnvVar = function (source) {
    if (typeof source === 'function') {
        return source();
    }
    if (typeof source === 'object') {
        return source[(0, exports.getEnvironment)()];
    }
    return source;
};
exports.getEnvVar = getEnvVar;
var createGetEnvVar = function (source) {
    return function () {
        return (0, exports.getEnvVar)(source);
    };
};
exports.createGetEnvVar = createGetEnvVar;
var getEnvVarWithOverride = function (source, overrideName) {
    if (overrideName) {
        if (typeof window !== 'undefined') {
            var value = window.localStorage.getItem(overrideName);
            if (value)
                return value;
        }
        else {
            var value = overrides[overrideName];
            if (value)
                return value;
        }
    }
    return (0, exports.getEnvVar)(source);
};
exports.getEnvVarWithOverride = getEnvVarWithOverride;
var createGetEnvVarWithOverride = function (source, overrideName) {
    return function () {
        return (0, exports.getEnvVarWithOverride)(source, overrideName);
    };
};
exports.createGetEnvVarWithOverride = createGetEnvVarWithOverride;
var overrideEnvVar = function (overrideName, value) {
    if (typeof window !== 'undefined') {
        window.localStorage.setItem(overrideName, value);
    }
    else {
        overrides[overrideName] = value;
    }
};
exports.overrideEnvVar = overrideEnvVar;
var createOverrideEnvVar = function (overrideName) { return function (value) {
    return (0, exports.overrideEnvVar)(overrideName, value);
}; };
exports.createOverrideEnvVar = createOverrideEnvVar;
var createEnvVarWithOverride = function (source, overrideName) { return ({
    get: (0, exports.createGetEnvVarWithOverride)(source, overrideName),
    set: (0, exports.createOverrideEnvVar)(overrideName),
}); };
exports.createEnvVarWithOverride = createEnvVarWithOverride;
//# sourceMappingURL=get-env-var.js.map